import { AuthHeader, CheckNafathResponse, LoginFailResponse } from 'api/evisaAPI/auth'
import { CallAPIAction, Status } from 'api/types'
import { EVISA_AUTH_HEADER } from 'common/constants'
import Actions from 'redux/actions'

type State = {
  token?: string
  isAgent?: boolean
  agentFor?: string
  authorized?: boolean
  mobileActive?: boolean
  error: string
} & Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
  isAgent: false,
  authorized: false,
  mobileActive: false,
  agentFor: '',
  token: undefined,
  error: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REGISTER_CHECK_NAFATH_ASYNC,
    Actions.REGISTER_CHECK_NAFATH_SUCCESS,
    Actions.REGISTER_CHECK_NAFATH_FAIL,
    CheckNafathResponse,
    LoginFailResponse,
    AuthHeader
  >,
) => {
  switch (action.type) {
    case Actions.REGISTER_CHECK_NAFATH_SUCCESS: {
      const token = action.headers[EVISA_AUTH_HEADER]

      return {
        ...state,
        ...action.status,
        isAgent: action.payload.is_agent,
        agentFor: action.payload.for?.name,
        authorized: action.payload.authorized,
        mobileActive: action.payload.mobile_active,
        token,
      }
    }
    case Actions.REGISTER_CHECK_NAFATH_ASYNC:
      return {
        ...state,
        ...action.status,
      }
    case Actions.REGISTER_CHECK_NAFATH_FAIL:
      return {
        ...state,
        ...action.status,
        error: action.payload?.error.message,
      }
    default:
      return state
  }
}
